<template>
  <div class="guest-layout">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'GuestLayout'
}
</script>

<style lang="scss">
.guest-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  width: 100%;
  height: 100vh;
  background-image: var(--linear-gradient-color-to-bottom-right);
  padding: 0 1rem;

  .title {
    margin-left: auto;
    margin-right: auto;

    font-size: 1.75rem;
    font-weight: 400;
    margin-bottom: 1.5rem;

    text-align: center;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1;

    @media (max-width: 600px) {
      font-size: 1.25rem;
      margin-bottom: 0;
    }
  }
}
</style>
